export default __webpack_public_path__ + "static/media/arrow-down-grey.de0b5b4d.svg";